import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import {
  UI_OPERATION_STATUS_ERROR,
  UI_OPERATION_STATUS_SUCCESS,
} from '@uncinc/react-drupal-core';

import Page from '../../containers/Page';
import useClasses from '../../hooks/useClasses';
import useOperationStatus from '../../hooks/useOperationStatus';
import useTypedDispatch from '../../hooks/useTypedDispatch';
import { buddyUnsubscribe } from '../../store/actions/Buddy';

import './style.scss';
import { Main } from '../../components';

const PageBuddyUnsubscribe = () => {
  const dispatch = useTypedDispatch();
  const status = useOperationStatus('buddy', 'unsubscribe');
  const { t } = useTranslation();
  const { buildClass } = useClasses('PageBuddyUnsubscribe');
  const { pairingCode } = useParams<{ pairingCode: string }>();

  const translationBase = 'pages.buddy_unsubscribe';

  useEffect(() => {
    if (pairingCode) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      dispatch(buddyUnsubscribe(pairingCode));
    }
  }, [pairingCode, dispatch]);

  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    <Page className={buildClass()} title={t(`${translationBase}.title`)}>
      <Main>
        <Container>
          <div className="row">
            <div className="col-md-10 col-lg-8 offset-md-1 offset-lg-2 py-8 py-lg-12">
              <div className={buildClass('title')}>
                <h1>{t(`${translationBase}.title`)}</h1>
              </div>

              <div className={buildClass('body')}>
                {status === UI_OPERATION_STATUS_SUCCESS && (
                <p>{t(`${translationBase}.body`)}</p>
                )}
                {status === UI_OPERATION_STATUS_ERROR && (
                <p>{t(`${translationBase}.error_message`)}</p>
                )}
              </div>
            </div>
          </div>
        </Container>
      </Main>
    </Page>
  );
};

export default PageBuddyUnsubscribe;
